import { api, downloadFile } from '@config/api';
import type { ColumnsExportOptions } from '@features/allocation';
import type {
  AllocationTag,
  AllocationTagBody,
  AllocationTagFilters,
  AllocationTagsResponse,
} from '../types/AllocationTag';

export const allocationTagService = {
  list: (filters: AllocationTagFilters, signal?: AbortSignal) =>
    api
      .get<AllocationTagsResponse>('/allocation-tags/management', { params: filters, signal })
      .then((r) => r.data),

  /** Com `page`, só aquela página do cadastro; sem, todas. */
  exportSpreadsheet: (
    filters: Omit<AllocationTagFilters, 'page'> & { page?: number },
    { format, columns, language }: ColumnsExportOptions,
  ) =>
    downloadFile('/allocation-tags/management/export', {
      ...filters,
      format,
      columns: columns.join(','),
      language,
    }),

  create: (body: AllocationTagBody) =>
    api.post<AllocationTag>('/allocation-tags', body).then((r) => r.data),

  update: (id: number, body: AllocationTagBody) =>
    api.patch<AllocationTag>(`/allocation-tags/${id}`, body).then((r) => r.data),

  remove: (id: number) => api.delete(`/allocation-tags/${id}`).then(() => undefined),
};
